import React from 'react';
import { fetchWrapper } from '../../APIManager';
const SearchStateContext = /*#__PURE__*/React.createContext();
const SearchDispatchContext = /*#__PURE__*/React.createContext();
const initialState = {
  moderators: []
};

/** REDUCER **/
function SearchReducer(state, action) {
  switch (action.type) {
    case 'GET_MODERATORS_LIST':
      return {
        ...state,
        moderators: action.payload
      };
    case 'GET_INITIAL':
      return initialState;
    default:
      {
        throw new Error('Unhandled action type caught');
      }
  }
}

/** PROVIDER **/
function SearchProvider(_ref) {
  let {
    value,
    children
  } = _ref;
  const [state, dispatch] = React.useReducer(SearchReducer, initialState);
  return /*#__PURE__*/React.createElement(SearchStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(SearchDispatchContext.Provider, {
    value: dispatch
  }, children));
}

/** STATE/DISPATCH HOOKS **/
function useSearchState() {
  const context = React.useContext(SearchStateContext);
  if (context === undefined) {
    throw new Error('useSearchState must be used within a SearchProvider');
  }
  return context;
}
function useSearchDispatch() {
  const context = React.useContext(SearchDispatchContext);
  if (context === undefined) {
    throw new Error('useSearchDispatch must be used within a SearchProvider');
  }
  return context;
}

/** API **/
const searchAPI = {
  searchUser: async function (url, apiKey, term, group) {
    try {
      const slug = `/u/search/users?term=${term}&group=${group}`;
      const response = await fetchWrapper(url, slug, apiKey);
      if (!response) {
        throw new Error('Failed to get search result of users');
      }
      return response;
    } catch (err) {
      return [];
    }
  },
  getModerators: async function (url, apiKey) {
    try {
      const slug = '/groups/moderators/members.json';
      const response = await fetchWrapper(url, slug, apiKey);
      if (!response) {
        throw new Error('Failed to get moderators data');
      }
      return response;
    } catch (err) {
      return [];
    }
  },
  searchTopic: async function (url, term, apiKey) {
    try {
      const typeFilter = 'topic';
      const searchForID = 'false';
      const restrictToArchetype = 'regular';
      const slug = `/search/query?term=${term}&type_filter=${typeFilter}&search_for_id=${searchForID}&restrict_to_archetype=${restrictToArchetype}`;
      const response = await fetchWrapper(url, slug, apiKey);
      if (!response) {
        throw new Error('Failed to get search result.');
      }
      return response;
    } catch (err) {
      return [];
    }
  },
  searchForum: async function (url, query, page, category, apiKey) {
    if (!category) return [];
    try {
      category = category.toLowerCase();
      query = category ? `${query} #${category}` : query;
      const slug = `/search.json?q=${encodeURIComponent(query)}&page=${page}`;
      const response = await fetchWrapper(url, slug, apiKey);
      if (!response) {
        throw new Error('Failed to get search result.');
      }
      return response;
    } catch (err) {
      return [];
    }
  }
};
export { SearchProvider, useSearchState, useSearchDispatch, searchAPI };
//# sourceMappingURL=index.js.map